import * as yup from 'yup';
import { confirmPassword, password, TranslateFn } from '../../../library/validationRules';

/**
 * The same rule `acceptInvitationSchema` applies to the same concept -- a password being
 * set for the first time. This page used to enforce nothing at all on the new password
 * and only checked that the confirmation matched it, so any single character got through
 * here and was then refused by the API.
 */
export const createChangePasswordSchema = (translate: TranslateFn) => yup.object({
    newPassword: password(translate),
    confirmPassword: confirmPassword(translate, 'newPassword'),
});
